// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/activity/v1/activity_api.proto (package gdx.activity.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { ActivityType } from "./activity_pb.js";
import { ProfilePreview } from "../../common/v1/profile_pb.js";

/**
 * @generated from message gdx.activity.v1.ListActivitiesRequest
 */
export class ListActivitiesRequest extends Message<ListActivitiesRequest> {
  /**
   * @generated from field: gdx.activity.v1.ListActivitiesRequest.ActivityDirection direction = 1;
   */
  direction = ListActivitiesRequest_ActivityDirection.INVALID;

  /**
   * @generated from field: string search_from = 2;
   */
  searchFrom = "";

  /**
   * @generated from field: repeated gdx.activity.v1.ActivityType types = 4;
   */
  types: ActivityType[] = [];

  /**
   * @generated from field: uint32 limit = 3;
   */
  limit = 0;

  constructor(data?: PartialMessage<ListActivitiesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.activity.v1.ListActivitiesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "direction", kind: "enum", T: proto3.getEnumType(ListActivitiesRequest_ActivityDirection) },
    { no: 2, name: "search_from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "types", kind: "enum", T: proto3.getEnumType(ActivityType), repeated: true },
    { no: 3, name: "limit", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListActivitiesRequest {
    return new ListActivitiesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListActivitiesRequest {
    return new ListActivitiesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListActivitiesRequest {
    return new ListActivitiesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListActivitiesRequest | PlainMessage<ListActivitiesRequest> | undefined, b: ListActivitiesRequest | PlainMessage<ListActivitiesRequest> | undefined): boolean {
    return proto3.util.equals(ListActivitiesRequest, a, b);
  }
}

/**
 * Activity direction type: incoming or outgoing.
 *
 * @generated from enum gdx.activity.v1.ListActivitiesRequest.ActivityDirection
 */
export enum ListActivitiesRequest_ActivityDirection {
  /**
   * @generated from enum value: ACTIVITY_DIRECTION_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: ACTIVITY_DIRECTION_IN = 1;
   */
  IN = 1,

  /**
   * @generated from enum value: ACTIVITY_DIRECTION_OUT = 2;
   */
  OUT = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(ListActivitiesRequest_ActivityDirection)
proto3.util.setEnumType(ListActivitiesRequest_ActivityDirection, "gdx.activity.v1.ListActivitiesRequest.ActivityDirection", [
  { no: 0, name: "ACTIVITY_DIRECTION_INVALID" },
  { no: 1, name: "ACTIVITY_DIRECTION_IN" },
  { no: 2, name: "ACTIVITY_DIRECTION_OUT" },
]);

/**
 * @generated from message gdx.activity.v1.ListActivitiesResponse
 */
export class ListActivitiesResponse extends Message<ListActivitiesResponse> {
  /**
   * @generated from field: repeated gdx.activity.v1.ListActivitiesResponse.ListItem activities = 1;
   */
  activities: ListActivitiesResponse_ListItem[] = [];

  constructor(data?: PartialMessage<ListActivitiesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.activity.v1.ListActivitiesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "activities", kind: "message", T: ListActivitiesResponse_ListItem, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListActivitiesResponse {
    return new ListActivitiesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListActivitiesResponse {
    return new ListActivitiesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListActivitiesResponse {
    return new ListActivitiesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListActivitiesResponse | PlainMessage<ListActivitiesResponse> | undefined, b: ListActivitiesResponse | PlainMessage<ListActivitiesResponse> | undefined): boolean {
    return proto3.util.equals(ListActivitiesResponse, a, b);
  }
}

/**
 * Describes activity item in list.
 *
 * @generated from message gdx.activity.v1.ListActivitiesResponse.ListItem
 */
export class ListActivitiesResponse_ListItem extends Message<ListActivitiesResponse_ListItem> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 2;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: gdx.common.v1.ProfilePreview profile = 3;
   */
  profile?: ProfilePreview;

  /**
   * @generated from field: string list_position = 4;
   */
  listPosition = "";

  /**
   * @generated from oneof gdx.activity.v1.ListActivitiesResponse.ListItem.type
   */
  type: {
    /**
     * @generated from field: gdx.activity.v1.ListActivitiesResponse.ActivityVisit visit = 5;
     */
    value: ListActivitiesResponse_ActivityVisit;
    case: "visit";
  } | {
    /**
     * @generated from field: gdx.activity.v1.ListActivitiesResponse.ActivityLike like = 6;
     */
    value: ListActivitiesResponse_ActivityLike;
    case: "like";
  } | {
    /**
     * @generated from field: gdx.activity.v1.ListActivitiesResponse.ActivityUnmatch unmatch = 7;
     */
    value: ListActivitiesResponse_ActivityUnmatch;
    case: "unmatch";
  } | {
    /**
     * @generated from field: gdx.activity.v1.ListActivitiesResponse.ActivityRequestPhoto request_photo = 8;
     */
    value: ListActivitiesResponse_ActivityRequestPhoto;
    case: "requestPhoto";
  } | {
    /**
     * @generated from field: gdx.activity.v1.ListActivitiesResponse.ActivityRequestPhotoUploaded request_photo_uploaded = 9;
     */
    value: ListActivitiesResponse_ActivityRequestPhotoUploaded;
    case: "requestPhotoUploaded";
  } | {
    /**
     * @generated from field: gdx.activity.v1.ListActivitiesResponse.ActivityZodiacCompatibility zodiac_compatibility = 10;
     */
    value: ListActivitiesResponse_ActivityZodiacCompatibility;
    case: "zodiacCompatibility";
  } | {
    /**
     * @generated from field: gdx.activity.v1.ListActivitiesResponse.ActivityPowerLike power_like = 11;
     */
    value: ListActivitiesResponse_ActivityPowerLike;
    case: "powerLike";
  } | {
    /**
     * @generated from field: gdx.activity.v1.ListActivitiesResponse.ActivitySexualCompatibility sexual_compatibility = 12;
     */
    value: ListActivitiesResponse_ActivitySexualCompatibility;
    case: "sexualCompatibility";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<ListActivitiesResponse_ListItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.activity.v1.ListActivitiesResponse.ListItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "created_time", kind: "message", T: Timestamp },
    { no: 3, name: "profile", kind: "message", T: ProfilePreview },
    { no: 4, name: "list_position", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "visit", kind: "message", T: ListActivitiesResponse_ActivityVisit, oneof: "type" },
    { no: 6, name: "like", kind: "message", T: ListActivitiesResponse_ActivityLike, oneof: "type" },
    { no: 7, name: "unmatch", kind: "message", T: ListActivitiesResponse_ActivityUnmatch, oneof: "type" },
    { no: 8, name: "request_photo", kind: "message", T: ListActivitiesResponse_ActivityRequestPhoto, oneof: "type" },
    { no: 9, name: "request_photo_uploaded", kind: "message", T: ListActivitiesResponse_ActivityRequestPhotoUploaded, oneof: "type" },
    { no: 10, name: "zodiac_compatibility", kind: "message", T: ListActivitiesResponse_ActivityZodiacCompatibility, oneof: "type" },
    { no: 11, name: "power_like", kind: "message", T: ListActivitiesResponse_ActivityPowerLike, oneof: "type" },
    { no: 12, name: "sexual_compatibility", kind: "message", T: ListActivitiesResponse_ActivitySexualCompatibility, oneof: "type" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListActivitiesResponse_ListItem {
    return new ListActivitiesResponse_ListItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListActivitiesResponse_ListItem {
    return new ListActivitiesResponse_ListItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListActivitiesResponse_ListItem {
    return new ListActivitiesResponse_ListItem().fromJsonString(jsonString, options);
  }

  static equals(a: ListActivitiesResponse_ListItem | PlainMessage<ListActivitiesResponse_ListItem> | undefined, b: ListActivitiesResponse_ListItem | PlainMessage<ListActivitiesResponse_ListItem> | undefined): boolean {
    return proto3.util.equals(ListActivitiesResponse_ListItem, a, b);
  }
}

/**
 * Activity type sexual compatibility.
 *
 * @generated from message gdx.activity.v1.ListActivitiesResponse.ActivitySexualCompatibility
 */
export class ListActivitiesResponse_ActivitySexualCompatibility extends Message<ListActivitiesResponse_ActivitySexualCompatibility> {
  /**
   * @generated from field: bool is_requested = 1;
   */
  isRequested = false;

  constructor(data?: PartialMessage<ListActivitiesResponse_ActivitySexualCompatibility>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.activity.v1.ListActivitiesResponse.ActivitySexualCompatibility";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "is_requested", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListActivitiesResponse_ActivitySexualCompatibility {
    return new ListActivitiesResponse_ActivitySexualCompatibility().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListActivitiesResponse_ActivitySexualCompatibility {
    return new ListActivitiesResponse_ActivitySexualCompatibility().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListActivitiesResponse_ActivitySexualCompatibility {
    return new ListActivitiesResponse_ActivitySexualCompatibility().fromJsonString(jsonString, options);
  }

  static equals(a: ListActivitiesResponse_ActivitySexualCompatibility | PlainMessage<ListActivitiesResponse_ActivitySexualCompatibility> | undefined, b: ListActivitiesResponse_ActivitySexualCompatibility | PlainMessage<ListActivitiesResponse_ActivitySexualCompatibility> | undefined): boolean {
    return proto3.util.equals(ListActivitiesResponse_ActivitySexualCompatibility, a, b);
  }
}

/**
 * Activity type zodiac compatibility.
 *
 * @generated from message gdx.activity.v1.ListActivitiesResponse.ActivityPowerLike
 */
export class ListActivitiesResponse_ActivityPowerLike extends Message<ListActivitiesResponse_ActivityPowerLike> {
  constructor(data?: PartialMessage<ListActivitiesResponse_ActivityPowerLike>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.activity.v1.ListActivitiesResponse.ActivityPowerLike";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListActivitiesResponse_ActivityPowerLike {
    return new ListActivitiesResponse_ActivityPowerLike().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListActivitiesResponse_ActivityPowerLike {
    return new ListActivitiesResponse_ActivityPowerLike().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListActivitiesResponse_ActivityPowerLike {
    return new ListActivitiesResponse_ActivityPowerLike().fromJsonString(jsonString, options);
  }

  static equals(a: ListActivitiesResponse_ActivityPowerLike | PlainMessage<ListActivitiesResponse_ActivityPowerLike> | undefined, b: ListActivitiesResponse_ActivityPowerLike | PlainMessage<ListActivitiesResponse_ActivityPowerLike> | undefined): boolean {
    return proto3.util.equals(ListActivitiesResponse_ActivityPowerLike, a, b);
  }
}

/**
 * Activity type zodiac compatibility.
 *
 * @generated from message gdx.activity.v1.ListActivitiesResponse.ActivityZodiacCompatibility
 */
export class ListActivitiesResponse_ActivityZodiacCompatibility extends Message<ListActivitiesResponse_ActivityZodiacCompatibility> {
  constructor(data?: PartialMessage<ListActivitiesResponse_ActivityZodiacCompatibility>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.activity.v1.ListActivitiesResponse.ActivityZodiacCompatibility";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListActivitiesResponse_ActivityZodiacCompatibility {
    return new ListActivitiesResponse_ActivityZodiacCompatibility().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListActivitiesResponse_ActivityZodiacCompatibility {
    return new ListActivitiesResponse_ActivityZodiacCompatibility().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListActivitiesResponse_ActivityZodiacCompatibility {
    return new ListActivitiesResponse_ActivityZodiacCompatibility().fromJsonString(jsonString, options);
  }

  static equals(a: ListActivitiesResponse_ActivityZodiacCompatibility | PlainMessage<ListActivitiesResponse_ActivityZodiacCompatibility> | undefined, b: ListActivitiesResponse_ActivityZodiacCompatibility | PlainMessage<ListActivitiesResponse_ActivityZodiacCompatibility> | undefined): boolean {
    return proto3.util.equals(ListActivitiesResponse_ActivityZodiacCompatibility, a, b);
  }
}

/**
 * Activity type visit.
 *
 * @generated from message gdx.activity.v1.ListActivitiesResponse.ActivityVisit
 */
export class ListActivitiesResponse_ActivityVisit extends Message<ListActivitiesResponse_ActivityVisit> {
  /**
   * @generated from field: bool is_liked = 1;
   */
  isLiked = false;

  /**
   * @generated from field: string dialog_id = 2;
   */
  dialogId = "";

  constructor(data?: PartialMessage<ListActivitiesResponse_ActivityVisit>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.activity.v1.ListActivitiesResponse.ActivityVisit";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "is_liked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "dialog_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListActivitiesResponse_ActivityVisit {
    return new ListActivitiesResponse_ActivityVisit().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListActivitiesResponse_ActivityVisit {
    return new ListActivitiesResponse_ActivityVisit().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListActivitiesResponse_ActivityVisit {
    return new ListActivitiesResponse_ActivityVisit().fromJsonString(jsonString, options);
  }

  static equals(a: ListActivitiesResponse_ActivityVisit | PlainMessage<ListActivitiesResponse_ActivityVisit> | undefined, b: ListActivitiesResponse_ActivityVisit | PlainMessage<ListActivitiesResponse_ActivityVisit> | undefined): boolean {
    return proto3.util.equals(ListActivitiesResponse_ActivityVisit, a, b);
  }
}

/**
 * Activity type like.
 *
 * @generated from message gdx.activity.v1.ListActivitiesResponse.ActivityLike
 */
export class ListActivitiesResponse_ActivityLike extends Message<ListActivitiesResponse_ActivityLike> {
  /**
   * @generated from field: string dialog_id = 1;
   */
  dialogId = "";

  constructor(data?: PartialMessage<ListActivitiesResponse_ActivityLike>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.activity.v1.ListActivitiesResponse.ActivityLike";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dialog_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListActivitiesResponse_ActivityLike {
    return new ListActivitiesResponse_ActivityLike().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListActivitiesResponse_ActivityLike {
    return new ListActivitiesResponse_ActivityLike().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListActivitiesResponse_ActivityLike {
    return new ListActivitiesResponse_ActivityLike().fromJsonString(jsonString, options);
  }

  static equals(a: ListActivitiesResponse_ActivityLike | PlainMessage<ListActivitiesResponse_ActivityLike> | undefined, b: ListActivitiesResponse_ActivityLike | PlainMessage<ListActivitiesResponse_ActivityLike> | undefined): boolean {
    return proto3.util.equals(ListActivitiesResponse_ActivityLike, a, b);
  }
}

/**
 * Activity type unmatched like.
 *
 * @generated from message gdx.activity.v1.ListActivitiesResponse.ActivityUnmatch
 */
export class ListActivitiesResponse_ActivityUnmatch extends Message<ListActivitiesResponse_ActivityUnmatch> {
  constructor(data?: PartialMessage<ListActivitiesResponse_ActivityUnmatch>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.activity.v1.ListActivitiesResponse.ActivityUnmatch";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListActivitiesResponse_ActivityUnmatch {
    return new ListActivitiesResponse_ActivityUnmatch().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListActivitiesResponse_ActivityUnmatch {
    return new ListActivitiesResponse_ActivityUnmatch().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListActivitiesResponse_ActivityUnmatch {
    return new ListActivitiesResponse_ActivityUnmatch().fromJsonString(jsonString, options);
  }

  static equals(a: ListActivitiesResponse_ActivityUnmatch | PlainMessage<ListActivitiesResponse_ActivityUnmatch> | undefined, b: ListActivitiesResponse_ActivityUnmatch | PlainMessage<ListActivitiesResponse_ActivityUnmatch> | undefined): boolean {
    return proto3.util.equals(ListActivitiesResponse_ActivityUnmatch, a, b);
  }
}

/**
 * Activity type request photo.
 *
 * @generated from message gdx.activity.v1.ListActivitiesResponse.ActivityRequestPhoto
 */
export class ListActivitiesResponse_ActivityRequestPhoto extends Message<ListActivitiesResponse_ActivityRequestPhoto> {
  constructor(data?: PartialMessage<ListActivitiesResponse_ActivityRequestPhoto>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.activity.v1.ListActivitiesResponse.ActivityRequestPhoto";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListActivitiesResponse_ActivityRequestPhoto {
    return new ListActivitiesResponse_ActivityRequestPhoto().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListActivitiesResponse_ActivityRequestPhoto {
    return new ListActivitiesResponse_ActivityRequestPhoto().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListActivitiesResponse_ActivityRequestPhoto {
    return new ListActivitiesResponse_ActivityRequestPhoto().fromJsonString(jsonString, options);
  }

  static equals(a: ListActivitiesResponse_ActivityRequestPhoto | PlainMessage<ListActivitiesResponse_ActivityRequestPhoto> | undefined, b: ListActivitiesResponse_ActivityRequestPhoto | PlainMessage<ListActivitiesResponse_ActivityRequestPhoto> | undefined): boolean {
    return proto3.util.equals(ListActivitiesResponse_ActivityRequestPhoto, a, b);
  }
}

/**
 * Activity type request photo was uploaded.
 *
 * @generated from message gdx.activity.v1.ListActivitiesResponse.ActivityRequestPhotoUploaded
 */
export class ListActivitiesResponse_ActivityRequestPhotoUploaded extends Message<ListActivitiesResponse_ActivityRequestPhotoUploaded> {
  constructor(data?: PartialMessage<ListActivitiesResponse_ActivityRequestPhotoUploaded>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.activity.v1.ListActivitiesResponse.ActivityRequestPhotoUploaded";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListActivitiesResponse_ActivityRequestPhotoUploaded {
    return new ListActivitiesResponse_ActivityRequestPhotoUploaded().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListActivitiesResponse_ActivityRequestPhotoUploaded {
    return new ListActivitiesResponse_ActivityRequestPhotoUploaded().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListActivitiesResponse_ActivityRequestPhotoUploaded {
    return new ListActivitiesResponse_ActivityRequestPhotoUploaded().fromJsonString(jsonString, options);
  }

  static equals(a: ListActivitiesResponse_ActivityRequestPhotoUploaded | PlainMessage<ListActivitiesResponse_ActivityRequestPhotoUploaded> | undefined, b: ListActivitiesResponse_ActivityRequestPhotoUploaded | PlainMessage<ListActivitiesResponse_ActivityRequestPhotoUploaded> | undefined): boolean {
    return proto3.util.equals(ListActivitiesResponse_ActivityRequestPhotoUploaded, a, b);
  }
}

/**
 * @generated from message gdx.activity.v1.MakeActivitiesReadRequest
 */
export class MakeActivitiesReadRequest extends Message<MakeActivitiesReadRequest> {
  constructor(data?: PartialMessage<MakeActivitiesReadRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.activity.v1.MakeActivitiesReadRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MakeActivitiesReadRequest {
    return new MakeActivitiesReadRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MakeActivitiesReadRequest {
    return new MakeActivitiesReadRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MakeActivitiesReadRequest {
    return new MakeActivitiesReadRequest().fromJsonString(jsonString, options);
  }

  static equals(a: MakeActivitiesReadRequest | PlainMessage<MakeActivitiesReadRequest> | undefined, b: MakeActivitiesReadRequest | PlainMessage<MakeActivitiesReadRequest> | undefined): boolean {
    return proto3.util.equals(MakeActivitiesReadRequest, a, b);
  }
}

/**
 * @generated from message gdx.activity.v1.MakeActivitiesReadResponse
 */
export class MakeActivitiesReadResponse extends Message<MakeActivitiesReadResponse> {
  constructor(data?: PartialMessage<MakeActivitiesReadResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.activity.v1.MakeActivitiesReadResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MakeActivitiesReadResponse {
    return new MakeActivitiesReadResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MakeActivitiesReadResponse {
    return new MakeActivitiesReadResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MakeActivitiesReadResponse {
    return new MakeActivitiesReadResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MakeActivitiesReadResponse | PlainMessage<MakeActivitiesReadResponse> | undefined, b: MakeActivitiesReadResponse | PlainMessage<MakeActivitiesReadResponse> | undefined): boolean {
    return proto3.util.equals(MakeActivitiesReadResponse, a, b);
  }
}

/**
 * @generated from message gdx.activity.v1.GetActivityStatusRequest
 */
export class GetActivityStatusRequest extends Message<GetActivityStatusRequest> {
  constructor(data?: PartialMessage<GetActivityStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.activity.v1.GetActivityStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActivityStatusRequest {
    return new GetActivityStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActivityStatusRequest {
    return new GetActivityStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActivityStatusRequest {
    return new GetActivityStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetActivityStatusRequest | PlainMessage<GetActivityStatusRequest> | undefined, b: GetActivityStatusRequest | PlainMessage<GetActivityStatusRequest> | undefined): boolean {
    return proto3.util.equals(GetActivityStatusRequest, a, b);
  }
}

/**
 * @generated from message gdx.activity.v1.GetActivityStatusResponse
 */
export class GetActivityStatusResponse extends Message<GetActivityStatusResponse> {
  /**
   * @generated from field: bool has_unread_activities = 1;
   */
  hasUnreadActivities = false;

  constructor(data?: PartialMessage<GetActivityStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.activity.v1.GetActivityStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "has_unread_activities", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActivityStatusResponse {
    return new GetActivityStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActivityStatusResponse {
    return new GetActivityStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActivityStatusResponse {
    return new GetActivityStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetActivityStatusResponse | PlainMessage<GetActivityStatusResponse> | undefined, b: GetActivityStatusResponse | PlainMessage<GetActivityStatusResponse> | undefined): boolean {
    return proto3.util.equals(GetActivityStatusResponse, a, b);
  }
}

